import { Box, BoxProps } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

function Article({ children, ...rest }: PropsWithChildren & BoxProps) {
    return (
        <Box as="article" paddingTop={{ base: 6, md: 10 }} {...rest}>
            {children}
        </Box>
    );
}

export default Article;
